<template>
  <div class="fluid-container">
    <menu-main></menu-main>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <!-- slide -->
          <div class="row no-gutters">
            <div class="col-12">
              <!-- slide -->
              <div class="slide">
                <carousel
                  paginationSize="20"
                  paginationActiveColor="#d7b4bd"
                  :perPage="perPage"
                  :autoplay="autoplay"
                  :autoplayHoverPause="autoPlayHover"
                  :autoplayTimeout="autoPlayVelocidad"
                >
                  <slide>
                    <div class="item item1">
                      <div class="caption">
                        <h2 class="font-weight-black">
                          TENEMOS TODOS
                          <br />
                          <span>LOS MUEBLES</span>
                          <br />
                          <span
                            style="
                              font-size: 52px;
                              line-height: 0;
                              position: relative;
                              top: -13px;
                            "
                            >PARA TU HOGAR!</span
                          >
                        </h2>

                        <v-btn
                          x-large
                          color="#c39767"
                          dark
                          class="font-weight-black title"
                          to="/productos"
                          >Conoce nuestros productos</v-btn
                        >
                      </div>
                    </div>
                  </slide>
                </carousel>
              </div>
              <!-- /slide -->
            </div>
          </div>
          <!-- /slide -->

          <!-- productos nuevos -->
          <div class="container">
            <div class="row mt-5">
              <div class="col-12">
                <h1 class="display-1 font-weight-black" style="color: #c39767">
                  PRODUCTOS NUEVOS
                </h1>
              </div>
            </div>
            <div class="row mt-5 mb-5">
              <div class="productos-items">
                <ul>
                  <li v-for="item in productos" :key="item.producto_id">
                    <!-- producto -->
                    <div class="producto-item">
                      <div class="imagen">
                        <img
                          style="padding: 0px"
                          v-if="item.imagen_destacada == ''"
                          src="https://vossmueblerias.com.mx/img/logo.eb8b33b4.png"
                          alt
                        />
                        <img v-else :src="item.imagen_destacada" alt />

                        <div class="info-wrap">
                          <span class="caption">{{ item.categoria }}</span>
                          <h2 class="title font-weight-black">
                            {{ item.nombre }}
                          </h2>
                          <h1 class="display-2 font-weight-black">
                            ${{ item.precio_pesos }}
                          </h1>
                          <v-btn
                            outlined
                            class="mt-3"
                            width="200px"
                            color="white"
                            >Ver producto</v-btn
                          >
                        </div>
                      </div>
                    </div>
                    <!-- /producto -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /productos nuevos -->

          <!-- nosotros -->
          <div class="row">
            <div class="col-xs-12 col-md-4"></div>
            <div class="col-xs-12 col-md-8">
              <h1>NOSOTROS</h1>
              <p>
                SOMOS UNA EMPRESA FAMILIAR COMPROMETIDOS AL 100% CON NUESTROS
                CLIENTES PARA BRINDARLES LA MEJOR CALIDAD, SERVICIO Y PRECIO DEL
                MERCADO, SIEMPRE A LA VANGUARDIA DE MANTENER NUESTROS REGIMEN DE
                CALIDAD Y HERRAMIENTA DE TALLER MODERNA PARA BRINDARTE DISENOS
                INIGUALABLES. NUESTROS MERCADO PRINCIPAL DE VENTAS SE ENCUENTRA
                EN ESTADOS UNIDOS Y MEXICO, POR LO QUE LOS ESTANDARES DE CALIDAD
                SIEMPRE FORMAN PARTE DE NUESTRA TENDENCIA DE VENTA Y ASI MISMO
                REFLEJARLO EN LA FELICIADAD Y SATISFACCION DE NUESTROS CLIENTES
                FINALES. CONTAMOS CON TALLER PROPIO PARA NUESTRA FABRICACION DE
                DISENOS EXCLUSIVOS, ADEMAS DE LA COMERCIALIZACION Y APOYO A
                TALLERES DEL INTERIOR DE LA REPUBLICA CON ESTANDARES DE ALTA
                CALIDAD PARA LA MAQUILA DE NUMEROSOS DISENOS DE NUESTROS
                CATALOGOS. Cada mueble elegido es parte del lenguaje visual de
                quien los posee. Se comunica con sus invitados sin usar
                palabras. Las formas, el color y los materiales crean un mensaje
                visual inconsciente que le invita a nuestros seres queridos y a
                uno mismo a disfrutar ese espacio. Nuestro compromiso es ofrecer
                los mejores muebles, al mejor precio, siempre a la vanguardia en
                diseño, con una actitud de servicio amable y proactiva. Más que
                un mueble lo que buscamos brindarte es una pieza excepcional que
                de ese sello de estilo a tu hogar. TE INVITAMOS A FORMAR PARTE
                DE NUESTROS CLIENTES SATISFECHOS.
              </p>
            </div>
          </div>
          <!-- /nosotros -->

          <!-- footer -->
          <footer-main></footer-main>
          <!-- /footer -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueGallery from "vue-gallery";
const axios = require("axios");
export default {
  data() {
    return {
      backgroundUrl: "/assets/img/slide.jpg",

      //Slide
      perPage: 1,
      autoplay: true,
      autoplayHover: false,
      autoPlayVelocidad: 4000,
      nav: true,

      //Productos
      productos: "",

      images: [
        "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80",
        "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80",
        "https://images.unsplash.com/photo-1540934498682-826b621ac95d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=934&q=80",
        "https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=934&q=80",
        "https://images.unsplash.com/photo-1464962634408-5970d4f0614d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
        "https://images.unsplash.com/photo-1493657654585-9df74851c60e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80",
        "https://images.unsplash.com/photo-1482482097755-0b595893ba63?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=934&q=80",
        "https://images.unsplash.com/photo-1441123694162-e54a981ceba5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
        "https://images.unsplash.com/photo-1486045409681-88a009db7239?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
      ],
      index: null,
    };
  },
  components: {
    gallery: VueGallery,
  },
  methods: {
    getProductos() {
      this.loaderProductos = true;
      //Obtenemos los productos
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/pagina/pagina__controller.php?ot=getProductosHome"
        )
        .then((response) => {
          console.log(response);
          this.loaderProductos = false;
          this.productos = response.data;
        })
        .catch((error) => console.log(error));
    },
  },
  mounted() {
    this.getProductos();
  },
};
</script>

<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
</style>
